
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["lucide lucide-wand-sparkles-icon lucide-wand-sparkles",classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","stroke":"currentColor","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"m21.64 3.64-1.28-1.28a1.21 1.21 0 0 0-1.72 0L2.36 18.64a1.21 1.21 0 0 0 0 1.72l1.28 1.28a1.2 1.2 0 0 0 1.72 0L21.64 5.36a1.2 1.2 0 0 0 0-1.72"}}),_c('path',{attrs:{"d":"m14 7 3 3"}}),_c('path',{attrs:{"d":"M5 6v4"}}),_c('path',{attrs:{"d":"M19 14v4"}}),_c('path',{attrs:{"d":"M10 2v2"}}),_c('path',{attrs:{"d":"M7 8H3"}}),_c('path',{attrs:{"d":"M21 16h-4"}}),_c('path',{attrs:{"d":"M11 3H9"}})])
          )
        }
      }
    